import '../App.css';
import 'animate.css';

function ProjectTemplate() {
  return (
    <div className="App">
      <div className="home-container">
        <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>
        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <a href="/">
          <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">← return home</h5>
        </a>
        <h1 className="animate__animated animate__fadeInUp animate__slow">COVID Kiosk</h1>
        <p className="animate__animated animate__fadeIn animate__slow animate__delay-2s">ReactJS, JavaScript, CSS, Bootstrap, and JSX.</p>
        
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-2s">
          <h3>
           Project Overview:
          </h3>
          <h2>
            The Symptom Kiosk is a easy to use, self-help kiosk designed to provide clear instructions. If they are clear to come into the building, they'll see a clear mark show up. If they aren't feeling well, or have a temperature, they will get a sick mark; And be asked to return home.
          </h2>
        </div>
        <div className="about">
          <h3>
           Project Highlights:
          </h3>
          <h2>
            <li>Built using React JS and JSX</li>
            <li>Built to get input data from Hardware</li>
          </h2>
        </div>
      
        <h3>View the Site at: <a target="_blank"  rel="noreferrer" href="https://symptomkiosk.netlify.app">symptomkiosk.netlify.app</a></h3>
       
        <h5 className="grey home-link">view privacy and site license —</h5>
      </div>

      
      
    </div>
  );
}

export default ProjectTemplate;
